export function isTokenCurrentlyValid(token = {}) {
    if (isTokenMarkedInvalid(token)) {
        return false;
    }

    if (isTokenExpired(token)) {
        return false;
    }

    if (isTokenAuthorizationNotAccepted(token)) {
        return false;
    }

    if (isTokenEnergyLimitReached(token)) {
        return false;
    }

    return true;
}

export function isMaxEnergyKwhInvalid(value) {
    if (value === null || value === undefined || value === "") {
        return false;
    }

    const number = Number(value);
    return !Number.isFinite(number) || number <= 0;
}

export function normalizeMaxEnergyKwh(value) {
    if (isMaxEnergyKwhInvalid(value)) {
        return null;
    }

    if (value === null || value === undefined || value === "") {
        return null;
    }

    return Number(value);
}

export function isTokenEnergyLimitReached(token = {}) {
    if (token.maxEnergyKwh == null) {
        return false;
    }

    return Number(token.accumulatedEnergyKwh ?? 0) >= Number(token.maxEnergyKwh);
}

export function isTokenMarkedInvalid(token = {}) {
    return token.isValid === false;
}

export function isTokenExpired(token = {}) {
    if (!token.expiredDateTimeUtc) {
        return false;
    }

    const expiry = new Date(token.expiredDateTimeUtc);
    if (Number.isNaN(expiry.getTime())) {
        return false;
    }

    return expiry.getTime() <= Date.now();
}

export function isTokenAuthorizationNotAccepted(token = {}) {
    const status = token.authorizationStatus;
    if (!status) {
        return true;
    }

    return status.localeCompare("Accepted", undefined, { sensitivity: "accent" }) !== 0;
}

export function getTokenValidLabel(token, t) {
    return isTokenCurrentlyValid(token) ? t("common.yes") : t("common.no");
}

export function getDecryptedTokenDisplay(token = {}, t) {
    if (token.decryptedTagToken) {
        return token.decryptedTagToken;
    }

    if (token.isFromOcpi) {
        return t("token.externalTokensHidden");
    }

    return "-";
}

